import { render, staticRenderFns } from "./thirdImport.vue?vue&type=template&id=5ef96bf9&scoped=true"
import script from "./thirdImport.vue?vue&type=script&lang=js"
export * from "./thirdImport.vue?vue&type=script&lang=js"
import style0 from "./thirdImport.vue?vue&type=style&index=0&id=5ef96bf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef96bf9",
  null
  
)

export default component.exports